module.exports = __webpack_public_path__ + "img/item9.599bda2b.png";